import styled, { css } from 'styled-components/macro';

export const Header = styled.div<{ $noDivider?: boolean }>`
  display: flex;
  gap: ${({ theme }) => theme.spacing.zero_2};
  align-items: center;
  padding: ${({ theme }) => theme.spacing.zero_3} ${({ theme }) => theme.spacing.one};
  border-bottom: ${({ theme, $noDivider }) =>
    $noDivider ? 'none' : `1px solid ${theme.colors.black_20}`};
`;

export const Title = styled.h5`
  flex: 1 0 0;
  min-width: 0;
  color: ${({ theme }) => theme.colors.black_100};
  font-family: ${({ theme }) => theme.fontFamily.semiBold};
  font-weight: ${({ theme }) => theme.fontWeight.semiBold};
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  word-break: break-word;
`;

export const Grid = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.one};
  align-items: stretch;

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.colors.black_20};
  }
`;

export const Label = styled.p`
  color: ${({ theme }) => theme.colors.black_80};
  font-family: ${({ theme }) => theme.fontFamily.regular};
  font-weight: ${({ theme }) => theme.fontWeight.regular};
  font-size: ${({ theme }) => theme.fontSize.xxs};
  line-height: 1rem;
  letter-spacing: ${({ theme }) => theme.letterSpacing.md};
`;

export const Value = styled.div`
  color: ${({ theme }) => theme.colors.black_100};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  word-break: break-word;
`;

export const Cell = styled.div<{ $highlighted?: boolean }>`
  display: flex;
  flex: 1 0 0;
  min-width: 0;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.zero_1};
  padding: ${({ theme }) => theme.spacing.one};

  ${({ theme, $highlighted }) =>
    $highlighted &&
    css`
      background-color: ${theme.colors.black_5};
      border: 1px solid ${theme.colors.black_40};
      border-radius: 0.5rem;
      box-shadow: 0 1px 1px rgba(0, 0, 0, 0.05);

      ${Value} {
        font-family: ${theme.fontFamily.semiBold};
        font-weight: ${theme.fontWeight.semiBold};
      }
    `}
`;

export const EmptyContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ theme }) => theme.spacing.one_1} ${({ theme }) => theme.spacing.two_1};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black_20};
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);
`;

export const EmptyText = styled.p`
  color: ${({ theme }) => theme.colors.black_100};
  font-family: ${({ theme }) => theme.fontFamily.medium};
  font-weight: ${({ theme }) => theme.fontWeight.medium};
  font-size: ${({ theme }) => theme.fontSize.xs};
  line-height: ${({ theme }) => theme.lineHeight.one_2};
  letter-spacing: ${({ theme }) => theme.letterSpacing.sm};
  text-align: center;
`;

export const Container = styled.div<{ $compact?: boolean; $fullHeight?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.one};
  margin: ${({ theme }) => theme.spacing.one} 0;
  ${({ $fullHeight }) => $fullHeight && 'flex: 1 1 auto;'}
  padding: ${({ theme }) => theme.spacing.zero_2} ${({ theme }) => theme.spacing.one_1};
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.black_40};
  border-radius: 0.75rem;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.04);

  ${({ theme, $compact }) =>
    $compact &&
    css`
      gap: ${theme.spacing.zero_2};
      padding: ${theme.spacing.zero_2} ${theme.spacing.zero_3};

      ${Header} {
        padding: ${theme.spacing.zero_2} ${theme.spacing.zero_2};
      }

      ${Cell} {
        padding: ${theme.spacing.zero_3} ${theme.spacing.zero_2};
      }
    `}
`;
